<template>
  <v-card id="project-summary__content">
    <v-row>
      <v-col cols="10">
        <balance-overview v-bind:isBalance="isBalanceValue"/>
      </v-col>
      <v-col cols="2">
        <selected-regions />
      </v-col>
    </v-row>
  </v-card>
  
</template>

<script>
import BalanceOverview from './BalanceOverview.vue'
import SelectedRegions from './SelectedRegions.vue'

export default {
  props: {
    isBalance : { 
      type: Boolean,
      required: true
    },
  },

  components: { BalanceOverview, SelectedRegions },

  computed: {
    isBalanceValue() {
      return this.isBalance;
    }
  },
}
</script>
